<template>
  <div class="tab-content-six__container">
    
    <!-- head -->
    <div class="content__head">
      <h2 class="content__head-title">{{ technicalTraining.title }}</h2>
      <p class="content__head-text" v-html="$convertPxToRem(technicalTraining.content)"></p>
    </div>

    <!-- img01 -->
    <div class="content__img-one"></div>

    <div class="content__two flex f-jus-center">
      <div class="content__two-left content__two-item flex f-column f-ali-center">
        <!-- img -->
        <div class="content__two__img-box flex f-center">
          <img src="../../../../assets/images1/customer_service/khfw26.png" class="content__two__img" />
        </div>
        <div class="content__two__body">
          <!-- title -->
          <h2 class="content__two__body__title" v-html="$convertPxToRem(technicalTraining.group1[0].title)"></h2>
          <!-- text -->
          <p class="content__two__body__content" v-html="$convertPxToRem(technicalTraining.group1[0].content)"></p>
        </div>
      </div>
      <div class="content__two-left content__two-item flex f-column f-ali-center">
        <!-- img -->
        <div class="content__two__img-box flex f-center">
          <img src="../../../../assets/images1/customer_service/khfw27.png" class="content__two__img" />
        </div>
        <div class="content__two__body">
          <!-- title -->
          <h2 class="content__two__body__title" v-html="$convertPxToRem(technicalTraining.group1[1].title)"></h2>
          <!-- text -->
          <p class="content__two__body__content" v-html="$convertPxToRem(technicalTraining.group1[1].content)"></p>
        </div>
      </div>
    </div>

    <!-- img02 -->
    <div class="content__img-two flex f-center">
      <div class="content__img__center-box flex f-column f-center">
        <h2 class="content__img__title">{{ technicalTraining.group2.title }}</h2>
        <p class="content__img__paragraph" v-for="item,i in technicalTraining.group2.txt_list" :key="i">
          {{ item }}
        </p>
      </div>
    </div>

    <div class="content__desc flex f-jus-center">
      <div class="content__desc-left">
        <div class="content__desc-title">{{ technicalTraining.group3.title }}</div>
        <div class="content__desc-paragraph">{{ technicalTraining.group3.subTitle }}</div>
        <ul class="content__desc-list">
          <li
          v-for="(txt, i) in technicalTraining.group3.list"
          :key="i"
          class="content__desc-list__item">
            <span>● </span>
            <span>{{ txt }}</span>
          </li>
        </ul>
      </div>
      <div class="content__desc-right">

      </div>
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'TabContentSix',

    data() {
        return {
          desc_text_list: [
            '控制阀的概念及结构简介。',
            '阀门及执行机构组件。',
            '执行机构及定位器校准和执行机构反作用。',
            '维护、检修及故障排除。',
            '控制阀尺寸计算及选型的基本原理。',
            '控制阀尺寸、选型和噪音计算。',
            '使用计算软件进行控制阀选型及尺寸计算。'
          ]
        }
    },

    computed: {
      ...mapGetters([
        'currentLang'
      ]),
      technicalTraining() {
        return this.currentLang.config.customerServicePage.technicalTraining
      },
    },

    created() {

    },

    methods: {}
}
</script>

<style scoped lang="scss">
.content__head {
  width: 1000px;
  height: auto;
  margin: 50px auto 80px;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
  }

  .content__head-text {
    line-height: 1.8;
    font-size: 18px;
    color: #777;
    text-align: justify;
    text-align-last: center;
  }
}

.content__img-one {
  height: 550px;
  background: url("../../../../assets/images1/customer_service/khfw25.jpg") no-repeat scroll;
  background-position: center center;
  background-size: cover;
}

.content__two {
  width: 100%;
  min-height: 830px;

  .content__two-item {
    margin: 100px 0;
    width: 560px;
    min-height: 600px;
    background-color: #F5F5F5;
  }
  
  .content__two-left {
    margin-right: 40px;
  }

  .content__two__img-box {
    width: calc(100% - 4px);
    height: 350px;
    border: 2px solid #E5E5E5;
    border-bottom: 0;
    background-color: #fff;
  }

  .content__two__body {
    width: 500px;
    margin: 30px 0;
  }

  .content__two__body__title {
    margin-bottom: 20px;
    color: #0F335E;
    font-weight: 500;
    letter-spacing: 1px;
  }

  .content__two__body__content {
    color: #777;
    font-size: 16px;
    line-height: 1.7;
    text-align: justify;
  }
}

.content__img-two {
  height: 550px;
  background: url("../../../../assets/images1/customer_service/khfw28.jpg") no-repeat scroll;
  background-position: center center;
  background-size: cover;

  .content__img__center-box {
    width: 1160px;
    min-height: 260px;
    padding: 20px 0;
    background: rgba($color: #fff, $alpha: 0.8);
  }

  .content__img__title {
    padding: 0;
    margin-bottom: 30px;
    font-size: 28px;
    font-weight: 500;
    letter-spacing: 1px;
  }

  .content__img__paragraph {
    margin-top: 10px;
    padding: 0 50px;
    text-align: justify;
    text-align-last: center;
    color: #777;
    font-size: 16px;
    line-height: 1.7;
  }
}


.content__desc {
  width: 100%;
  height: 550px;
  background-color: #fff;

  .content__desc-left {
    margin-top: 80px;
    width: 760px;
  }

  .content__desc-title {
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #0F335E;
  }

  .content__desc-paragraph {
    margin: 26px 0 36px;
    color: #777;
    font-size: 18px;
    line-height: 1.8;
    text-align: justify;
  }

  .content__desc-list__item {
    color: #777;
    font-size: 18px;
    line-height: 2;
  }

  .content__desc-right {
    margin: 100px 0 0 100px;
    width: 250px;
    height: 250px;
    background: url("../../../../assets/images1/customer_service/khfw29.png") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home_customer_service/components/TabContentSix.vue